import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/common/Layout';
import LandingPage from './pages/Landing/LandingPage';
import UploadPage from './pages/Upload/UploadPage';
import ProcessingPage from './pages/Processing/ProcessingPage';
import ResultsPage from './pages/Results/ResultsPage';

function App() {
    return (
        <AnimatePresence mode="wait">
            <Layout>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/upload" element={<UploadPage />} />
                    <Route path="/processing" element={<ProcessingPage />} />
                    <Route path="/results" element={<ResultsPage />} />
                </Routes>
            </Layout>
        </AnimatePresence>
    );
}

export default App;
